import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import remoteActions from './remote.actions';

import AppError from 'src/app/model/app-error';

@Injectable()
export class RemoteEffects {
  initStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(remoteActions.initStart),
      switchMap(({ id }) =>
        this.apiService.getRemoteInit(id).pipe(
          map((data) =>
            data.message === 'Success'
              ? remoteActions.initSuccess({ success: data })
              : remoteActions.initError({ error: data as unknown as AppError }),
          ),
          catchError((error: AppError) => of(remoteActions.initError({ error }))),
        ),
      ),
    ),
  );

  sendSmsTokenStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(remoteActions.sendSmsTokenStart),
      switchMap(({ id }) =>
        this.apiService.postRemoteSendSmsToken(id).pipe(
          map((data) =>
            data.message === 'Success'
              ? remoteActions.sendSmsTokenSuccess({ success: data })
              : remoteActions.sendSmsTokenError({ error: data as unknown as AppError }),
          ),
          catchError((error: AppError) => of(remoteActions.sendSmsTokenError({ error }))),
        ),
      ),
    ),
  );

  sendSmsTokenVerifyStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(remoteActions.verifySmsTokenStart),
      switchMap(({ id, otp }) =>
        this.apiService.getRemoteVerify(id, otp).pipe(
          map((data) =>
            data.message === 'Success'
              ? remoteActions.verifySmsTokenSuccess({ success: data })
              : remoteActions.verifySmsTokenError({ error: data as unknown as AppError }),
          ),
          catchError((error: AppError) => of(remoteActions.verifySmsTokenError({ error }))),
        ),
      ),
    ),
  );

  constructor(private store: Store<AppState>, private apiService: ApiService, private actions$: Actions, private router: Router) {}
}
